module.exports = __webpack_public_path__ + "img/evapharma.001833e6.jpg";